import React from 'react'
import { Grid } from '@material-ui/core'

import Utils from '@utils'
import Input from '@components/Input'
import Stepper from '@components/Stepper'

import Status from '@constants/status.constansts'

const ConfigComponent = props => {
  const { formik } = props
  const { handleBlur, handleChange, values, errors } = formik

  const status = [
    {
      label: 'Rascunho',
      value: Status.DRAFT
    },
    {
      label: 'Publicado',
      value: Status.PUBLISHED
    }
  ]

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs className="mg-auto">
          <Grid item xs={12} sm={12}>
            <Input
              {...props}
              name="title"
              onBlur={handleBlur}
              onChange={handleChange}
              label="POST_ADD_EDIT_INPUT_LABEL_TITLE"
              value={Utils.getValue(values, 'title')}
              error={Utils.getValue(errors, 'title')}
              helperText={Utils.getValue(errors, 'title')}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Input
              {...props}
              name="summary"
              onBlur={handleBlur}
              onChange={handleChange}
              label="POST_ADD_EDIT_INPUT_LABEL_SUB_TITLE"
              value={Utils.getValue(values, 'summary')}
              error={Utils.getValue(errors, 'summary')}
              helperText={Utils.getValue(errors, 'summary')}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Input
              {...props}
              name="author"
              onBlur={handleBlur}
              onChange={handleChange}
              label="POST_ADD_EDIT_INPUT_LABEL_AUTHOR"
              value={Utils.getValue(values, 'author')}
              error={Utils.getValue(errors, 'author')}
              helperText={Utils.getValue(errors, 'author')}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Input
              {...props}
              translate
              type="select"
              name="status"
              array={status}
              nameText="label"
              nameValue="value"
              onBlur={handleBlur}
              onChange={handleChange}
              label="POST_ADD_EDIT_INPUT_LABEL_STATUS"
              value={Utils.getValue(values, 'status')}
              error={Utils.getValue(errors, 'status')}
              helperText={Utils.getValue(errors, 'status')}
            />
          </Grid>
        </Grid>
        <Grid item xs={4} sm={4} className="mg-auto">
          <Input
            {...props}
            name="banner"
            type="cropper"
            aspectRatio={6 / 4}
            onBlur={handleBlur}
            onChange={handleChange}
            value={Utils.getValue(values, 'banner')}
            error={Utils.getValue(errors, 'banner')}
            helperText={Utils.getValue(errors, 'banner')}
          />
        </Grid>
      </Grid>
    </>
  )
}

const PostComponent = props => {
  const { formik } = props
  const { handleBlur, handleChange, values, errors } = formik

  return (
    <Input
      {...props}
      name="blocks"
      type="editor"
      onBlur={handleBlur}
      onChange={handleChange}
      value={Utils.getValue(values, 'blocks')}
      error={Utils.getValue(errors, 'blocks')}
      helperText={Utils.getValue(errors, 'blocks')}
    />
  )
}

const FormGroup = props => {
  const steps = [
    {
      label: 'POST_STEPS_LABEL_CONFIG',
      component: props => <ConfigComponent {...props} />
    },
    {
      label: 'POST_ADD_CARD_TITLE',
      component: props => <PostComponent {...props} />
    }
  ]

  return <Stepper {...props} steps={steps} />
}

export default FormGroup
